import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthenticationService } from "../../../../../../services/security/authentication.service";
import { RecordAction } from "../../../../../../utils/enums/shared/enums";
import { PeriodContactability } from "../../../../../../utils/types/period-contactability/periodContactability.type";
import { PeriodContactabilityService } from "../../../../../../services/period-contactability/period-contactability.service";
import { TranslateService } from "@ngx-translate/core";
@Component({
    selector: "wtf-protocol-form",
    templateUrl: "./period-contactability-form.component.html",
    styleUrls: ["./period-contactability-form.component.scss"],
    providers: [PeriodContactabilityService, AuthenticationService],
    encapsulation: ViewEncapsulation.None,
})
export class PeriodContactabilityFormComponent implements OnInit {
    protocolModel: PeriodContactability;
    dialogTitle: string;
    protocolForm: FormGroup;
    action: RecordAction;
    callback: (protocol) => void;

    operators: any;
    // presetColors = MatColors.presets;
    recordAction = RecordAction;

    constructor(
        public dialogRef: MatDialogRef<PeriodContactabilityFormComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private service: PeriodContactabilityService,
        private translateService: TranslateService
    ) {
        this.translateService.setDefaultLang("en");
        this.translateService.use(localStorage.getItem("language") || "en");
        this.protocolModel = data.protocol;
        this.action = data.action;
        this.callback = data.callback;

        if (
            this.action === RecordAction.Update ||
            this.action === RecordAction.View
        ) {
            this.dialogTitle = this.protocolModel.name;
        } else {
            this.dialogTitle = "Nuevo Periodo";
            this.dialogTitle = this.translateService.instant(this.dialogTitle);
            this.protocolModel = new PeriodContactability();
        }

        this.protocolForm = this.createForm();
    }

    ngOnInit() {}

    createForm() {
        const form = new FormGroup({
            name: new FormControl(this.protocolModel.name),
            active: new FormControl(Boolean(this.protocolModel.active)),
        });

        form.controls["name"].valueChanges.subscribe(
            (value) => (this.protocolModel.name = value)
        );
        form.controls["active"].valueChanges.subscribe(
            (value) => (this.protocolModel.active = value)
        );
        return form;
    }

    performAction() {
        if (this.protocolForm.invalid) {
            return;
        }

        this.callback(this.protocolModel);
    }
}
